import { Image } from "antd";
import { create } from "zustand";
import { MAIN_URL } from "../../Constants";
import axios from "axios";
import SumFormater from "../../utils/SumFormater";

export const useShItems = create((set, get) => ({
    data: [],
    shops: [],
    transfers: [],
    setData: (d) => set({ data: d }),
    getVitrina: () => axios.get('vitrina').then(res => set({ data: res.data })),
    getShops: () => axios.get('shops').then(r => set({ shops: r.data })),
    getTransfer: ()=> axios.get('transfer').then(res=>set({transfers: res.data})),
    /*
        "id": 37,
        "pr_id": 29,
        "b_u": 0,
        "quality": "1",
        "parametr": "Lumen",
        "manufacturer_id": 4,
        "sku": "195198189",
        "price_uzs": "0",
        "price_usd": "0.00",
        "dis_uzs": "0",
        "dis_usd": "0.00",
        "in_uzs": "0",
        "in_usd": "0.00",
        "deleted_at": 0,
        "min_count": 4,
        "country": "O'zbekiston",
        "color": "OQ",
        "color_code": "#f9fafa",
        "manufacturer": "Nachalo"
        */
    columns: [
        {
            title: "Rasm",
            dataIndex: "img",
            key: "img",
            width: 100,
            render: (img) => (img && <Image src={MAIN_URL + '/' + img} width={64} />),
        },
        {
            title: "Nomi (SKU)",
            dataIndex: "nameuz",
            key: "nameuz",
        },
        {
            title: "Kategoriya",
            dataIndex: "catname",
            key: "catname",
        },
        {
            title: "Narx",
            dataIndex: "price_uzs",
            key: "price_uzs",
            align: "right",
            render: (price_uzs) => SumFormater(price_uzs)
        },
        {
            title: "Magazin nomi",
            dataIndex: "shopname",
            key: "shopname",
        },
        {
            title: "Magazindagi qoldiq",
            dataIndex: "shopcount",
            key: "shopcount",
            align: "right",
        }
    ]
}))